import api from "../../../api";
import React from "react";
import values from "../../../values";
import ParentScreen from "..";

import { useQuery } from "react-query";
import Context from "../../../context";
import { ICreateAndUpdateParent } from "../../../types/parent.interface";
import utils from "../../../utils";
import { DeleteModal } from "../../../components";
import { TModal } from "../../../types/common.type";
import Cookies from "js-cookie";
import constants from "../../../values/constants";

const ParentContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                              Values Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedParent, setSelectedParent] = React.useState<any>();

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  let cityInfo: any;

  Cookies.get("city") != "undefined"
    ? (cityInfo = JSON.parse(Cookies.get("city") as string))
    : (cityInfo = undefined);

  const [requestParent, setRequestParent] = React.useState<any>({
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    page: 1,
    filters: {
      city: userType !== "COMPANY" && cityInfo?._id,
    },
  });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultParent = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      requestParent?.page,
      requestParent?.search?.value,
      requestParent?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.common.findParent({
        filters: requestParent?.filters,
        search: requestParent?.search,
        limit: requestParent?.limit,
        page: requestParent?.page,
        academicYear: selectedYear?._id,
      }),
    {
      enabled:
        requestParent?.search?.base === "PHONE_NUMBER" &&
        requestParent?.search?.value?.length >= 8,
    }
  );

  //   const getAllParent = useQuery(
  //     ["parent", values.useQueryKeys.getAllParent],
  //     () => api.post.common.findParent({})
  //   );
  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                              Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateParent) {
    setIsLoading(true);
    const result = await api.post.common.createParent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateParent) {
    setIsLoading(true);
    console.log(formData);

    const result = await api.put.common.updateParent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.common.deleteParent(userId);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                Start API Cal
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.ParentScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        requestParent,
        selectedParent,
        createFunction,
        updateFunction,
        deleteFunction,
        setRequestParent,
        setSelectedParent,
      }}
    >
      <ParentScreen resultParent={resultParent} />
      <DeleteModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "DELETE"}
        loading={isLoading}
        onSubmit={deleteFunction}
        user={selectedParent}
      />
    </Context.ParentScreen.Provider>
  );
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default ParentContainer;
